import { Outlet, Link } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { TopNavigation } from '@/components/navigation/top-navigation'
import { BottomNavigation } from '@/components/navigation/bottom-navigation'
import { SideNavigation } from '@/components/navigation/side-navigation'
import { useInteractionStore } from '@/stores/interaction-store'
import { POST_CATEGORIES } from '@/constants'
import { apiAdapter } from '@/lib/api-adapter'

// 最新加入的用户（真实数据）
function RecentUsers() {
  const [users, setUsers] = useState<any[]>([])

  useEffect(() => {
    let cancelled = false
    apiAdapter.users.getUsers({ page: 1, limit: 3 })
      .then((res: any) => {
        if (!cancelled && res.success && res.data?.users) {
          setUsers(res.data.users.slice(0, 3))
        }
      })
      .catch(() => {})
    return () => { cancelled = true }
  }, [])

  if (users.length === 0) return null

  return (
    <div className="bg-white rounded-lg p-4 shadow-sm">
      <h3 className="font-semibold text-gray-900 mb-3">最新加入</h3>
      <div className="space-y-3">
        {users.map((u: any) => (
          <Link key={u._id} to={`/user/${u._id}`} className="flex items-center gap-3 group">
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
              <span className="text-blue-600 text-sm font-medium">
                {(u.nickname || u.username || '?')[0]}
              </span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 group-hover:text-blue-600 truncate">
                {u.nickname || u.username}
              </p>
              <p className="text-xs text-gray-500">
                {u.postsCount || 0} 条动态
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}

export default function Layout() {
  // 初始化互动功能数据
  const { initializeData } = useInteractionStore()
  
  useEffect(() => {
    initializeData()
  }, [initializeData])

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-cyan-50">
      <TopNavigation />
      
      {/* 单一路由出口：桌面侧边栏/右侧栏用 CSS 控制显隐，避免组件双挂载 */}
      <div className="pt-16">
        {/* 桌面左侧导航（仅 lg+ 显示） */}
        <aside className="hidden lg:block fixed left-0 top-16 w-64 h-[calc(100vh-4rem)] bg-white/80 backdrop-blur-md border-r border-gray-200 p-4 overflow-y-auto">
          <SideNavigation />
        </aside>
        
        {/* 主内容区：桌面留出两侧空间，移动端全宽 */}
        <main className="lg:ml-64 lg:mr-80 px-4 lg:px-6 py-6 pb-20 lg:pb-6">
          <div className="max-w-2xl mx-auto">
            <Outlet />
          </div>
        </main>
        
        {/* 桌面右侧信息栏（仅 lg+ 显示） */}
        <aside className="hidden lg:block fixed right-0 top-16 w-80 h-[calc(100vh-4rem)] bg-white/80 backdrop-blur-md border-l border-gray-200 p-4 overflow-y-auto">
          <div className="space-y-4">
            {/* 内容分类 */}
            <div className="bg-white rounded-lg p-4 shadow-sm">
              <h3 className="font-semibold text-gray-900 mb-3">内容分类</h3>
              <div className="space-y-1">
                {POST_CATEGORIES.map(cat => (
                  <Link
                    key={cat.id}
                    to={`/category/${encodeURIComponent(cat.name)}`}
                    className="flex items-center justify-between text-sm px-2 py-1.5 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <span className="text-gray-700">{cat.icon} {cat.name}</span>
                    <span className="text-gray-400">→</span>
                  </Link>
                ))}
              </div>
            </div>

            {/* 最新加入的用户 */}
            <RecentUsers />

            {/* 平台说明 */}
            <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg p-4 text-white">
              <h3 className="font-semibold mb-2">大悟万能墙</h3>
              <p className="text-sm opacity-90 leading-relaxed">
                大悟县校园社交平台。分享校园生活、学习互助、二手交易、失物招领。
              </p>
            </div>
          </div>
        </aside>
      </div>
      
      {/* 移动端底部导航（仅移动端显示） */}
      <div className="lg:hidden">
        <BottomNavigation />
      </div>
    </div>
  )
}
